
export const FIELD_TYPES = {
  INPUT: "input",
  SELECT: "select",
  TEXTAREA: "textarea",
  CHECKBOX: "checkbox",
  RADIO: "radio",
  DATE: "date"
};

export const VALIDATION_TYPES = {
    NOTBLANK: "notBlank",
    PHONE: "phone",
    EMAIL: "email",
    DNI: "dni",
    CIF: "cif"
};
